import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {oneLight} from 'react-syntax-highlighter/dist/esm/styles/prism';

// 使用 react-markdown + remark-gfm + react-syntax-highlighter 来渲染 Markdown

class DocumentTab extends React.PureComponent {
    render () {
        const {vm} = this.props;
        if (!vm) return null;

        const targets = [];
        try {
            if (vm.runtime.getTargetForStage) targets.push(vm.runtime.getTargetForStage());
            if (vm.runtime.targets && vm.runtime.targets.length) targets.push(...vm.runtime.targets);
        } catch (e) {
            // noop
        }

        const matches = [];
        for (const target of targets) {
            if (!target) continue;
            const comments = target.comments || (target.blocks && target.blocks._comments) || {};
            const values = Object.values(comments || {});
            for (const c of values) {
                const text = (c && (c.text || c)) || '';
                if (String(text).indexOf('#README') !== -1) {
                    // 去掉第一次出现的 #README 标志
                    const cleaned = String(text).replace(/#README\s*/i, '');
                    matches.push(cleaned.trim());
                }
            }
        }

        const md = matches.length > 0 ? matches.join('\n\n---\n\n') : '# 未找到 README 注释\n\n请在作品注释中包含 `#README` 来显示文档。';

        return (
            <div style={{padding: 12, overflow: 'auto'}}>
                <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                        code({node, inline, className, children, ...props}) {
                            const match = /language-(\w+)/.exec(className || '');
                            return !inline && match ? (
                                <SyntaxHighlighter style={oneLight} language={match[1]} PreTag="div">
                                    {String(children).replace(/\n$/, '')}
                                </SyntaxHighlighter>
                            ) : inline ? (
                                <code style={{background: 'rgba(0,0,0,0.05)', padding: '0 4px'}}>{String(children)}</code>
                            ) : (
                                <code>{String(children)}</code>
                            );
                        }
                    }}
                >
                    {md}
                </ReactMarkdown>
            </div>
        );
    }
}

DocumentTab.propTypes = {
    vm: PropTypes.object
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm
});

export default connect(mapStateToProps)(DocumentTab);
